import { Record, Set } from 'immutable';

export const CollectionRecord = Record({
  id: 0,
  owner: '',
  name: '',
  ships: Set(),
  retrofits: Set(),
  version: 1,
});
